// extracted by mini-css-extract-plugin
export default {"icon":"ServiceRowRemove--icon--33bc6d"};